'use client';
import React from 'react';

const data = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://invtron.com/#organization",
      "name": "Invtron DAO",
      "url": "https://invtron.com",
      "logo": {
        "@type": "ImageObject",
        "url": "https://invtron.com/favicon.png"
      }
    },
    {
      "@type": "WebSite",
      "@id": "https://invtron.com/#website",
      "url": "https://invtron.com",
      "name": "Invtron DAO",
      "publisher": {
        "@id": "https://invtron.com/#organization"
      }
    }
  ]
};

const StructuredData = () => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
  />
);

export default StructuredData;
